<template>
  <sui-segment>
    <sui-grid verticalAlign="middle">
      <sui-grid-row>
        <sui-grid-column :width="8">
          <div style="float:left">
            <sui-button id="backButton" color="black" @click.prevent="back" icon="arrow left" basic size="medium" style=" margin: 0.4em 0.4em 0; " />
          </div>
          <div style="float:left">
            <h2 is="sui-header">
              Impressum
              <sui-header-subheader></sui-header-subheader> <!-- LoL -->
            </h2>
          </div>
        </sui-grid-column>
      </sui-grid-row>
    </sui-grid>
    <br />
    <fieldset>
      LAN1 Hotspots GmbH<br />
      Gaußstraße 158<br />
      D-22765 Hamburg<br />
      <br />
      Tel.: 	+49 (0)40 317 66 66 0<br />
      Fax.: 	+49 (0)40 317 66 66 33<br />
      E-mail: info[at]lan1.de<br />
      www: lan1.de<br />
      Handelsregister Hamburg HRB 118700<br />
      Umsatzsteuer-Identifikationsnummer<br />
      gemäß §27 a Umsatzsteuergesetz: DE277065194<br />
      Geschäftsführung: Jörg Hümmer<br />
                                   <br />
                                   <br />
    </fieldset>

  </sui-segment>
</template>
<script>
  export default {
    data() {
      return {
        fromRoute: null,
        fallbackRoute: '/',
      };
    },
    beforeRouteEnter(to, from, next) {
      next(vm => { vm.fromRoute = from })
    },
    methods: {
      back() {
        if (this.fromRoute === null || !this.fromRoute.name) {
          this.$router.push(this.fallbackRoute)
        } else {
          this.$router.back()
        }
      },
    }
  };
</script>
